import React from "react";
import SEO from "@/components/SEO";
import FinalCTA from "@/components/FinalCTA";
import { COMPANY, IMG } from "@/data/site";
import { Award, ShieldCheck, Users, MapPin, Phone } from "lucide-react";

const AboutPage = () => (
  <>
    <SEO
      title="About Crosstown Movers | Wyoming's Trusted Movers Since 1980"
      description="Crosstown Movers is a locally owned Wyoming moving company serving Casper, Mills, and surrounding areas since 1980. Learn our story, values, and commitment to care."
      path="/about"
    />
    <section className="py-20 md:py-28 bg-[var(--ct-bg)]">
      <div className="section-container grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="label-xs text-[var(--ct-primary)] mb-3">About Crosstown Movers</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>
            Wyoming's moving company for {COMPANY.yearsInBusiness}+ years.
          </h1>
          <p className="mt-6 text-[var(--ct-text-muted)] leading-relaxed text-lg">
            Since 1980, Crosstown Movers has been the trusted moving company for Casper, Mills, and central Wyoming.
            What started as a small local crew has grown into one of the most respected moving companies in the state —
            but we've never forgotten our roots: care, honesty, and hard work.
          </p>
          <p className="mt-4 text-[var(--ct-text-muted)] leading-relaxed">
            We're proud to be locally owned, fully insured, and 4.5-star rated by our neighbors. Whether it's a
            single-item heavy lift or a full office relocation, our crews bring the same attention to detail and
            genuine friendliness every time.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="/#quote" className="btn-primary">Get a Free Quote</a>
            <a href={`tel:${COMPANY.phoneTel}`} className="btn-outline"><Phone className="w-4 h-4" /> {COMPANY.phone}</a>
          </div>
        </div>
        <div className="rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(0,0,0,0.12)]">
          <img src={IMG.hero} alt="Crosstown Movers Wyoming team" className="w-full h-[540px] object-cover" />
        </div>
      </div>
    </section>

    <section className="py-20 bg-white">
      <div className="section-container grid md:grid-cols-4 gap-6">
        {[
          { icon: <Award />, n: `${COMPANY.yearsInBusiness}+`, l: "Years in Wyoming" },
          { icon: <Users />, n: "1000s", l: "Moves Completed" },
          { icon: <ShieldCheck />, n: "4.5★", l: "Customer Rating" },
          { icon: <MapPin />, n: "8+", l: "Cities Served" },
        ].map((s, i) => (
          <div key={i} className="p-7 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] text-center">
            <div className="w-12 h-12 mx-auto rounded-xl bg-[var(--ct-primary)] text-white flex items-center justify-center">
              {React.cloneElement(s.icon, { className: "w-5 h-5" })}
            </div>
            <div className="mt-4 text-3xl font-bold text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>{s.n}</div>
            <div className="mt-1 text-xs tracking-[0.2em] uppercase text-[var(--ct-text-muted)]">{s.l}</div>
          </div>
        ))}
      </div>
    </section>

    <FinalCTA />
  </>
);

export default AboutPage;
